import { render, staticRenderFns } from "./tile-avatar.vue?vue&type=template&id=696b7407"
import script from "./tile-avatar.vue?vue&type=script&lang=ts"
export * from "./tile-avatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696b7407')) {
      api.createRecord('696b7407', component.options)
    } else {
      api.reload('696b7407', component.options)
    }
    module.hot.accept("./tile-avatar.vue?vue&type=template&id=696b7407", function () {
      api.rerender('696b7407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tile/tile-avatar.vue"
export default component.exports